import React from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import src from "../../images/nophoto_lg.png";

const useStyles = makeStyles(theme => ({
  content: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      padding: '16px 0',
  },
  logo: {

      "& img": {
          width: '50px',
          height: '50px',
          border: '1px solid #CACCD1',
          boxSizing: 'border-box',
          borderRadius: '25px',
      }
  },
  info: {
    marginLeft: "16px",
      "& h5": {
          fontFamily: 'Montserrat',
          fontStyle: 'normal',
          fontWeight: 'normal',
          fontSize: '14px',
          lineHeight: '18px',
          color: '#000000',
          margin: '0 0 8px 0',
      },
      "& p": {
          fontFamily: 'Montserrat',
          fontStyle: 'normal',
          fontWeight: 'normal',
          fontSize: '10px',
          lineHeight: '12px',
          textTransform: 'uppercase',
          color: '#596E79'
      }
  }
}));

const CardPersonBlock = ({ image, name, desc, personId }) => {
  const classes = useStyles();
  const baseURL = "/work/api/file";

  return (
    <div className={classes.content}>
      <div className={classes.logo}>
          {image ?
              <img src={`${baseURL}/${image}`} />
          :
              <img src={src} />
          }
      </div>
      <div className={classes.info}>
          {name &&
            <h5>
              {(personId && personId > -1)
                ? <a href={`/work/app/person/${personId}`}
                     title="Перейти к карточке сотрудника"
                     target="_blank">{name}</a>
                : name
              }
            </h5>
          }
          <p>{desc}</p>
      </div>
      </div>
  );
};

export default CardPersonBlock;
